import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function lettersOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid = /^[a-zA-ZçÇğĞıİöÖşŞüÜ\s]*$/.test(control.value);
    return valid ? null : { lettersOnly: true };
  };
}

export function sixDigitNumberValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const valid = /^\d{6}$/.test(control.value);
    return valid ? null : { sixDigitNumber: { value: control.value } };
  };
}

export function numberOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const valid = /^[0-9]+$/.test(control.value);
    return valid ? null : { numberOnly: { value: control.value } };
  };
}
export function optionalMinLength(minLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const val = control.value;
    if (!val) { // boşsa valid kabul et
      return null;
    }
    return val.length >= minLength ? null : { minlength: { requiredLength: minLength, actualLength: val.length } };
  };
}

export function optionalPattern(pattern: string | RegExp): ValidatorFn {
  const regex = typeof pattern === 'string' ? new RegExp(pattern) : pattern;
  return (control: AbstractControl): ValidationErrors | null => {
    const val = control.value;
    console.log('Validating with pattern:', regex, 'for value:', val);
    if (val == null || val === '' || val.length === 3 || val.length === 4) {
      // null veya boş string ise valid kabul et
      return null;
    }
    return regex.test(val) ? null : { pattern: { requiredPattern: regex.toString(), actualValue: val } };
  };
}

export function validateAtLeastOneMethodSelectedPerType(types: any[], methods: any[]): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    if (!(group instanceof FormGroup)) return null;

    for (let type of types) {
      const hasAtLeastOne = methods.some(method => {
        const key = `notification_${type.id}_${method.id}`;
        return group.get(key)?.value === true;
      });

      if (!hasAtLeastOne) {
        return { atLeastOneMethodRequired: true };
      }
    }

    return null;
  };
}